import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainLink = styled.a`
  display: inline-block;
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: -0.1px;
  text-align: center;
  color: #4a90e2;
  cursor: pointer;
  padding: 4px 0;
  margin: 8px 0;
  &:hover {
    opacity: 0.9;
  }
  &:hover,
  &:focus,
  &:visited {
    text-decoration: none;
  }
  ${(props) => props.block
    && `
    width: 100%;
  `}
`;

const Link = (props) => {
  const {
    text, href, block, tabIndex, onClick,
  } = props;
  const options = {
    tabIndex,
    block,
  };

  if (href) {
    options.href = href;
  }

  if (onClick) {
    options.onClick = onClick;
  }

  return <MainLink {...options}>{text}</MainLink>;
};

Link.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  block: PropTypes.bool,
  tabIndex: PropTypes.string,
  onClick: PropTypes.func,
};

Link.defaultProps = {
  text: 'link',
  href: '',
  block: false,
  tabIndex: null,
  onClick: () => {},
};

export default Link;
